<template>
  <div class="account-tab-item">
    <template v-if="isMob">
      <div v-if="!pending" class="account-tab-item__table-wrap">
        <div class="account-tab-item__head-mob">
          <div class="account-tab-item__filter-btn-wrap">
            <button type="button"
                    class="account-tab-item__filter-btn"
                    @click.prevent="onOpenFilterMob">
              <BaseSvg name="ico-filter" class="_filter" width="1.3rem" height="1.3rem"/>
              <span>{{ $tAccount('Set filters') }}</span>
              <BaseSvg name="ico-arrow-light" class="_arrow" width=".4rem" height=".6rem"/>
            </button>
          </div>
        </div>
      </div>
      <div v-if="pending"
           style="position: relative; padding: 3rem 2rem"
           class="account-tab-item__group">
        <BasePreloader/>
      </div>
      <div v-else-if="!items || !items.length"
           style="padding: 3rem 2rem; text-align: center"
           class="account-tab-item__group  text">
        <p>{{ $tAccount('You dont have income') }}</p>
      </div>
      <div v-else
           class="account-tab-item__group">
        <AccountTabItemHistoryRowMobile v-for="item in items"
                                        :key="item.id"
                                        :item="item"/>
      </div>
    </template>

    <table v-else class="account-tab-item__table">
      <AccountTabItemHistoryHeaderDesktop v-if="filters"
                                          :filters="filters"
                                          :isChecked="isChecked"
                                          :onToggleFilter="onToggleFilter"
                                          :onClear="onClear"
                                          :filterSelectedProperties="filterSelectedProperties"/>
      <tbody>
      <tr v-if="pending">
        <td colspan="6" style="position: relative; padding: 4rem 0">
          <BasePreloader/>
        </td>
      </tr>
      <tr v-else-if="!items || !items.length">
        <td colspan="6"
            class="text"
            style="position: relative; padding: 3rem 2rem; text-align: center">
          <p>{{ $tAccount('You dont have income') }}</p>
        </td>
      </tr>
      <template v-else>
        <AccountTabItemHistoryRowDesktop v-for="item in items"
                                         :key="item.id"
                                         :item="item"/>
      </template>
      </tbody>
    </table>
    <div class="account-tab-item__pagination-wrap">
      <Pagination class="account-tab-item__pagination"
                  :style="paginationStyle"
                  :quantity="pagesQuantity"/>
      <AccountBalanceInfo :label="$tAccount('Available for withdrawal')"
                          :value="balance"
                          withdraw
                          class="account-tab-item__pagination-btn"
      />
    </div>

    <transition name="fade">
      <AccountTabItemHistoryHeaderMobile v-if="showFilterMob && filters"
                                         :filters="filters"
                                         :isChecked="isChecked"
                                         :onToggleFilter="onToggleFilter"
                                         :onClear="onClear"
                                         @close="onCloseFilterMob"
                                         v-click-out="onCloseFilterMob"
                                         :filterSelectedProperties="filterSelectedProperties"
      />
    </transition>
  </div>
</template>

<script>
  import AccountTabItemHistoryRowDesktop from './AccountTabItemHistoryRowDesktop'
  import AccountTabItemHistoryRowMobile from './AccountTabItemHistoryRowMobile'
  import AccountBalanceInfo from './AccountBalanceInfo'
  import AccountTabItemHistoryHeaderDesktop from './AccountTabItemHistoryHeaderDesktop'
  import AccountTabItemHistoryHeaderMobile from './AccountTabItemHistoryHeaderMobile'
  import {blockScroll, unBlockScroll} from '@/helpers/scroll'
  import Pagination from '@/components/Pagination'
  import {http} from '@/axios'
  import capitalize from '@/helpers/capitalize'

  const filtersKeys = [
    'types',
    'operations',
    'operation_who',
    'partners',
  ]

  export default {
    name: 'AccountTabItemHistory',
    components: {
      AccountBalanceInfo,
      Pagination,
      AccountTabItemHistoryRowDesktop,
      AccountTabItemHistoryRowMobile,
      AccountTabItemHistoryHeaderDesktop,
      AccountTabItemHistoryHeaderMobile,
    },
    props: {
      isMob: {
        type: Boolean,
        default: false
      },
      balance: Number
    },
    data() {
      return {
        pending: false,
        items: null,
        filters: null,
        pagesQuantity: 0,

        showFilterMob: false,

        timer: null,
      }
    },
    computed: {
      paginationStyle() {
        if (this.pending) {
          return {
            pointerEvents: 'none',
            opacity: '0.5'
          }
        }

        return null
      },

      ...getComputedProperties(),

      filterSelectedProperties() {
        const result = filtersKeys.reduce((result, key) => {
          const values = this[createFiltersName(key)]

          if (values.length) {
            result[key] = values
          }

          return result
        }, {})

        return result
      },
    },
    methods: {
      load() {
        this.pending = true

        const params = {
          page: this.$route.query.page || 1,
          ...this.filterSelectedProperties
        }

        http.get('/api/cabinet/payments/history', {
          params
        }).then(({data}) => {
          console.log('history', data)
          this.items = data.data.data
          this.filters = data.filters
          this.pagesQuantity = data.data.last_page
        }).catch(error => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        })
      },
      isChecked([key, valueId]) {
        const values = this[createFiltersName(key)]

        return values.some(value => {
          return Number(value) === Number(valueId)
        })
      },
      onToggleFilter([key, valueId]) {
        const values = [...(this.filterSelectedProperties[key] || [])]

        const valueIndex = values.findIndex(value => {
          return Number(value) === Number(valueId)
        })

        if (valueIndex >= 0) {
          values.splice(valueIndex, 1)
        } else {
          values.push(valueId)
        }

        const query = JSON.parse(JSON.stringify(this.filterSelectedProperties))

        if (values.length) {
          query[key] = values
        } else {
          delete query[key]
        }

        for (const key in query) {
          query[key] = query[key].join('|')
        }

        this.$router.push({
          query
        })
      },

      onClear(key) {
        const query = JSON.parse(JSON.stringify(this.$route.query))
        delete query[key]

        this.$router.push({
          query
        })
      },
      onOpenFilterMob() {
        blockScroll()
        this.showFilterMob = true
      },
      onCloseFilterMob() {
        unBlockScroll()
        this.showFilterMob = false
      },
      checkMob() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (!this.isMob) {
            this.onCloseFilterMob()
          }
        }, 200)
      }
    },
    created() {
      this.load()
    },
    watch: {
      '$route.query'() {
        this.load()
      }
    },
    mounted() {
      window.addEventListener('resize', this.checkMob)
    },
    beforeDestroy() {
      this.onCloseFilterMob()
      window.removeEventListener('resize', this.checkMob)
    }
  }

  function createFiltersName(key) {
    const name = key.split('_').reduce((result, item) => {
      return result + capitalize(item)
    }, '')

    return 'filters' + name
  }

  function getComputedProperties() {
    return filtersKeys.reduce((result, key) => {
      result[createFiltersName(key)] = function () {
        const r = this.$route.query[key]
        return r ? r.split('|') : []
      }

      return result
    }, {})
  }
</script>

<style>

</style>
